export default __webpack_public_path__ + "static/media/email.829abff2.svg";